import React from "react";
import UserManagerPage from "./UserManagerPage";
import {useQuery} from "@apollo/client";
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon, IonLabel,
    IonLoading,
    IonSpinner
} from "@ionic/react";
import {
    keyOutline,
    keySharp,
    pencilOutline,
    pencilSharp, readerOutline, readerSharp,
} from "ionicons/icons";
import {USER_GET_ROLE_DATA_QUERY, USER_GET_ROLES_QUERY} from "../../schemas/userManager";


const UserManagerRoles: React.FC<any> = () => {

    const [roleId, setRoleId] = React.useState<number | undefined>(undefined);
    const {loading:rolesLoading, error:rolesError, data: rolesData} = useQuery(USER_GET_ROLES_QUERY, {variables: {}});
    const {loading:roleLoading, error:roleError, data: roleData} = useQuery(USER_GET_ROLE_DATA_QUERY, {variables: {id: roleId}, skip: !roleId});


    return (
        <UserManagerPage page={'roles'}>
            <IonLoading isOpen={rolesLoading}/>
            {!rolesLoading && rolesData &&
                <div className="userManagerContent">
                    <IonButton size="small" color="light" routerLink={'/user-manager/create-role'} routerDirection="forward">
                        <IonLabel>+ Add Role</IonLabel>
                    </IonButton>
                    <p style={{marginTop: '20px'}}><b>Number of Roles:</b> {rolesData.getRoles.length}</p>
                    <table style={{width: '100%'}}>
                        <tbody>
                        <tr>
                            <td style={{
                                verticalAlign: "top",
                                width: !roleData?.getRoleData?.id && !roleLoading ? '100%' : 'auto',
                                padding: "0px"
                            }}>

                                <table style={{
                                    width: '100%',
                                }} className="striped">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Details</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rolesData && rolesData.getRoles && rolesData.getRoles.map((role: any) => {
                                        return (
                                            <tr key={'role_' + role.id} onClick={() => setRoleId(role.id)}>
                                                <td>
                                                    <div style={{
                                                        marginRight: '20px',
                                                        display: "inline-block",
                                                        borderRadius: '20px',
                                                        backgroundColor: role.color ? role.color : '#990099',
                                                        color: 'white',
                                                        lineHeight: '40px',
                                                        height: '40px',
                                                        width: '40px',
                                                        textAlign: 'center',
                                                        verticalAlign: 'center'
                                                    }}>{role.name.substr(0, 1)}</div>
                                                    {role.name}
                                                </td>
                                                <td>
                                                    {role.details}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </td>

                            <td style={{width: '10px', padding: '0px'}}></td>
                            <td style={{
                                verticalAlign: "top",
                                width: !roleLoading && !roleData?.getRoleData.id ? '0px' : '350px',
                                padding: '0px'
                            }}>

                                {roleLoading && roleId &&
                                    <IonCard style={{
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        margin: '0px',
                                        width: '100%', top:'0px', position: 'sticky'
                                    }}>
                                        <IonCardContent>
                                            <div style={{position: 'relative', width: '100%', height: '100%', lineHeight: '100%', verticalAlign: 'middle'}}>
                                                <IonSpinner style={{position: 'sticky', left: '50%', top: '50%'}}></IonSpinner>
                                            </div>
                                        </IonCardContent>
                                    </IonCard>
                                }
                                {roleData && roleData.getRoleData && roleData.getRoleData.id && !roleLoading && roleData.getRoleData.role_rules &&
                                    <IonCard style={{
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        margin: '0px',
                                        width: '100%', top:'0px', position: 'sticky'
                                    }}>
                                        <IonCardHeader style={{borderBottom: '1px solid #cccccc'}}>

                                            <IonCardTitle style={{float: 'left'}}>{roleData.getRoleData.name}</IonCardTitle>

                                            <div style={{
                                                display: 'inline-block',
                                                verticalAlign: 'top',
                                                float: 'right'
                                            }}>
                                                <IonButton fill="clear" size="small" href={"/user-manager/edit-role/" + roleData.getRoleData.id}><IonIcon md={pencilOutline} ios={pencilSharp}></IonIcon></IonButton>
                                            </div>
                                            <div style={{clear: "both"}}></div>
                                        </IonCardHeader>
                                        <IonCardContent style={{padding:'10px'}}>

                                            <table style={{width: '100%'}}>
                                                <tbody>
                                                <tr>
                                                    <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                        <b><IonIcon md={readerOutline} ios={readerSharp}></IonIcon></b>
                                                    </td>
                                                    <td><b>Details:</b></td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {roleData &&
                                                            <>{roleData.getRoleData.details}</>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                        <b><IonIcon md={keyOutline} ios={keySharp}></IonIcon></b>
                                                    </td>
                                                    <td><b>Rules:</b></td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {roleData && roleData.getRoleData.role_rules && roleData.getRoleData.role_rules.map((userRule: any) => {
                                                            return (<div key={'rules_' + userRule.rules.id}>
                                                                {userRule.rules.name}<br/>
                                                            </div>)
                                                        })
                                                        }
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                        </IonCardContent>

                                    </IonCard>
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            }
        </UserManagerPage>
);
};


export default UserManagerRoles;